import React, { useEffect, useState } from "react";
import { ScrollView, View } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppColors } from "../../../../utility/AppColors";
import { ShowLoader } from "../../../../common/ShowLoader";
import { getLoginData } from "../../../../utility/AppStoreData";
import { AppImages } from "../../../../utility/AppImages";

import { MobileHeader } from "../../../../Components/MobileHeader";
import { toast } from "react-toastify";
import { useChatApi } from "../../../../utility/hooks/useChatApi";
import AddFriendSearch from "../../../../Components/add-friend-common-components/AddFriendSearch";
import SocialMediaShare from "../../../../Components/add-friend-common-components/SocialMediaShare";
import Header from "../Common/Header";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import { ScreenBGGradientView } from "../../../../common/CommonView";

export default function AddFriends() {
  const styles = useStyles();
  const [username, setUsername] = useState("");
  const [currentUsername, setCurrentUsername] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const navigation = useNavigation();
  // const [showLoader, setShowLoader] = useState(false);
  const [arrSocialMedia] = useState([
    { id: 1, name: "Instagram", image: AppImages.icSocialInsta },
    { id: 2, name: "Whatsapp", image: AppImages.icSocialWhatsapp },
    { id: 3, name: "Twitter", image: AppImages.icSocialTwitter },
    { id: 4, name: "Facebook", image: AppImages.icSocialFacebook },
    // { id: 4, name: "Snapchat", image: AppImages.icSocialSnapChat },
    // { id: 5, name: "Tiktok", image: AppImages.icSocialTiktok },
  ]);

  const { chatCreateAPI, showLoader } = useChatApi();

  useEffect(() => {
    getLoginUserData((data) => {
      if (data.username) {
        setCurrentUsername(data.username);
        setAccessToken(data.AccessToken);
      }
    });
  }, []);

  async function getLoginUserData(successResponse) {
    const data = await getLoginData();
    if (data != null) {
      successResponse(data);
    }
  }

  const handleSendRequest = () => {
    if (username === "") {
      toast.error("Please enter username");
    } else {
      const members = [username];
      chatCreateAPI(members, accessToken, "single");
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <ScreenBGGradientView />
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {
          // setTooltipVisible(true);
        }}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />
      <View style={styles.container}>
        <View style={styles.container}>
          <ScrollView style={{ backgroundColor: "Red" }}>
            <AddFriendSearch
              username={username}
              setUsername={setUsername}
              onSendRequest={handleSendRequest}
              currentUsername={currentUsername}
              showBtnLoader={showLoader}
            />
            <SocialMediaShare
              arrSocialMedia={arrSocialMedia}
              username={currentUsername}
              marginVertical={10}
              btnMarginBottom={10}
            />
          </ScrollView>
          {showLoader && <ShowLoader showIndicater={showLoader} />}
        </View>
      </View>
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "2%",
      paddingTop: "2.5%",
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      container: {
        paddingHorizontal: "3.5%",
      },
    },
  }
);
